import React from 'react';
import './calculate.css';
import CalcBody from './calcBody';

const calculator = () => (
  <div className="calculator">
    <CalcBody />
  </div>
);

export default calculator;
